import { Vector3 } from 'three'
import type { ThreeEvent } from '@react-three/fiber'

export type CubeFace = 'front' | 'back' | 'left' | 'right' | 'top' | 'bottom'

const faceDirections: Record<CubeFace, Vector3> = {
  front: new Vector3(0, 0, 1),
  back: new Vector3(0, 0, -1),
  left: new Vector3(-1, 0, 0),
  right: new Vector3(1, 0, 0),
  top: new Vector3(0, 1, 0),
  bottom: new Vector3(0, -1, 0),
}

export const clickCubeFace = async ({
  face,
  setRotationTo,
  waitForCameraIdle,
}: {
  face: CubeFace
  setRotationTo: (e: ThreeEvent<MouseEvent>, direction: Vector3) => null
  waitForCameraIdle: () => Promise<void>
}) => {
  const direction = faceDirections[face]

  if (!direction) {
    throw new Error(`Unknown cube face: ${face}`)
  }

  setRotationTo(
    {
      stopPropagation: () => {},
    } as ThreeEvent<MouseEvent>,
    direction.clone(),
  )

  await waitForCameraIdle()
}
